import { alertConstants } from '../constants';
import { getStore } from '../store-ref';
import { showToast } from '../new_services/toasts';

export const alertActions = {
  success,
  error,
  clear,
};

// Side-effect-on-call: these helpers are typically invoked from sagas /
// non-thunk action creators that don't carry a dispatch reference. We
// reach for the store directly so the call sites stay untouched while the
// underlying toast plumbing moves to the in-house slice.
function success(message, title = '') {
  getStore()?.dispatch(showToast({ kind: 'info', title, caption: `${message}` }));
  return { type: alertConstants.SUCCESS, message };
}

function error(message, title = '') {
  const caption = message?.message || message?.error || String(message);
  getStore()?.dispatch(showToast({ kind: 'error', title, caption }));
  return { type: alertConstants.ERROR, message };
}

function clear() {
  return { type: alertConstants.CLEAR };
}
